export const px2rem = (px, designWidth = 375) => {
  const rootValue = designWidth / 10 // amfe-flexible 默认以 375 设计稿为基准
  return `${px / rootValue}rem`
}
